import { api } from '../api';
import { LoginAsCamp, ts, useLoad } from '../lib';

// Commerce activation scoreboard (Track F1) — proxied from order.tavezio.io via the admin BFF's
// service key. Read-only beta telemetry: per-camp first order, orders placed, guides, savings shown.
export function ActivationPanel() {
  const { data, err } = useLoad(() => api.commerceActivation());
  const t = data?.totals;
  return (
    <div className="stack">
      <h1>Activation</h1>
      <p className="sub">Per-camp activation telemetry from commerce — first order, orders placed, guides created, savings shown</p>
      {err && <p className="msg bad">⚠ {err}</p>}
      <section className="card">
        <table>
          <thead><tr><th>Camp account</th><th>First order</th><th className="num">Orders</th><th className="num">Guides</th><th className="num">Savings shown</th><th>Last activity</th><th></th></tr></thead>
          <tbody>
            {t && (
              <tr style={{ fontWeight: 600 }}>
                <td>All camps ({t.orgs_with_order}/{t.orgs} ordered)</td>
                <td>—</td>
                <td className="num">{t.orders_placed.toLocaleString()}</td>
                <td className="num">{t.guides_created.toLocaleString()}</td>
                <td className="num">{t.savings_shown.toLocaleString()}</td>
                <td>—</td>
                <td />
              </tr>
            )}
            {(data?.rows ?? []).map((r) => (
              <tr key={r.org_id}>
                <td>{r.name}</td>
                <td className="mono">{ts(r.first_order_at)}</td>
                <td className="num">{r.orders_placed}</td>
                <td className="num">{r.guides_created}</td>
                <td className="num">{r.savings_shown}</td>
                <td className="mono">{ts(r.last_event_at)}</td>
                <td><LoginAsCamp orgId={r.org_id} name={r.name} /></td>
              </tr>
            ))}
            {data && data.rows.length === 0 && <tr><td colSpan={7} className="loading">No camps.</td></tr>}
          </tbody>
        </table>
        {!data && !err && <p className="loading">Loading…</p>}
      </section>
    </div>
  );
}
